export const FILLWORD_LOADED = 'FILLWORD_LOADED';
export const FILLWORD_UNLOAD = 'FILLWORD_UNLOAD';